import { IAiReplaceSlideMobileService } from './ai-replace-slide-service.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IMobileToolbarEditManager } from '../mobile-toolbar-edit-manager/core/mobile-toolbar-edit-manager.interface';
import { EditPanelType } from '@src/framework/frame-m/components/edit-panel-m/const';
import { ReplaceSlideAIMobileContainer } from '@com-m/edit-panel-m/replace-slide-ai/replace-slide-ai';
import React from 'react';
import PullPanel from '@tencent/dui-mobile/lib/components/PullPanel';
import { IAIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import {
    IMobilePreviewThumbnailListService,
} from '@src/slide/application/service/mobile-preview-thumbnail-list/core/type';
import { PANEL_HEADER_HEIGHT } from '@src/slide/application/service/slide-rating-and-improve/view/mobile/result/constant';
import LayoutHeader from '@com-m/pull-panel-m/layout-header';
import i18n from '@i18next/i18n';
import { LIST_VISIBLE_POSITION } from '@com-m/list';

export class AiReplaceSlideServiceMobile implements IAiReplaceSlideMobileService {
    public constructor(
        private uiDataService: IUiDataService,
        private aiAssistantService: IAIAssistantService,
        private mobileToolbarEditManager: IMobileToolbarEditManager,
        private mobilePreviewListService: IMobilePreviewThumbnailListService,
    ) {}

    public showPanel() {
        this.mobileToolbarEditManager.openEditPanel(null, EditPanelType.AI_REPLACE_SLIDE);
    }

    public showPanelInPreview() {
        const slideModel = this.mobilePreviewListService.getPreviewListLastTouchSlideModel();
        const slideIndex = slideModel?.presentationRef?.indexOfSlide(slideModel);
        if (slideIndex !== undefined && slideIndex !== -1) {
            this.mobilePreviewListService?.scrollToCellAtIndex?.(slideIndex, LIST_VISIBLE_POSITION.TOP);
        }
        const panel = PullPanel.show({
            pullable: false,
            mask: true,
            maskClosable: true,
            panelHeight: window.screen.height / 2,
            headerStyle: { height: `${PANEL_HEADER_HEIGHT}px`, padding: '0 0' },
            header: <LayoutHeader
                onClose={() => {
                    panel.close();
                }}
                title={i18n.t('AI 单页美化')}>
            </LayoutHeader>,
            content:
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <ReplaceSlideAIMobileContainer
                        onClose={() => {
                            panel.close();
                        }}
                        startCurrentId={
                            slideModel?.id ?? ''
                        }
                        notShowTitle={true}
                        sourceSlideModel={slideModel}
                        uiDataService={this.uiDataService}
                        aiAssistantService={this.aiAssistantService}
                    />
                </div>,
        });
    }

    public canUseAIReplace(slide: ISlideModel): boolean {
        return !!slide?.sdkData?.getOwnedData().cSld.spTree?.nvPr.descr;
    }
}
